<template>
    <div class="nav">
        <div class="logo">
            <img src="https://ciwei-mall.oss-cn-beijing.aliyuncs.com/image/logo.png" alt="">
        </div>
        <div class="name" :style="'color:'+logoColor">非遗数字化工程中心</div>
        <div class="item">
            <a href="javascript:void(0)" @click="open(item,index)"
               :style="item.selected?'color: orange':''" v-for="(item,index) in topMenu">{{item.name}}</a>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import logo from "@/assets/logo.png";

    export default {
        name: "top-nav",
        data() {
            return {
                logo: logo
            }
        },
        methods: {
            refresh: function () {
                window.location.reload();
            },
            open: function (item,index) {
                if (item.isReload) {
                    window.location.reload()
                    return;
                }
                window.open(this.topMenu[index].link);
                this.$store.commit(item.mutations);
            }
        },
        computed: {
            ...mapGetters([
                'logoColor', 'topMenu'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .nav {
        height: 80px;
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        position: relative;
        z-index: 11;
        .logo {
            img {
                width: 60px;
                height: 60px;
            }
        }
        .name {
            color: #fff;
            font-size: 25px;
            font-weight: bold;
            margin-left: 20px;
            transition: color ease .8s;
        }
        .item {
            flex-grow: 1;
            text-align: right;
            a {
                color: #fff;
                font-size: 18px;
                margin: 0 20px;
                text-decoration: none;
                text-shadow: 0 1px 2px #888888;
            }
        }
    }
</style>